import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CategoryState {
  postCategoryName: string;
  rankCategoryName: string;
  companyCorpName: string;
  companySectorName: string;
  reportCategoryName: string;
  postCategoryId: number;
  rankCategoryId: number;
  companyCorpId: number;
  companySectorId: number;
  reportCategoryId: number;
}

const initialState: CategoryState = {
  postCategoryName: '열람율',
  rankCategoryName: '전체',
  companyCorpName: '전체',
  companySectorName: '전체',
  reportCategoryName: null,
  postCategoryId: 0,
  rankCategoryId: null,
  companyCorpId: null,
  companySectorId: null,
  reportCategoryId: 0
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setPostCategoryName: (state, action: PayloadAction<string>) => {
      state.postCategoryName = action.payload;
    },
    setRankCategoryName: (state, action: PayloadAction<string>) => {
      state.rankCategoryName = action.payload;
    },
    setCompanyCorpName: (state, action: PayloadAction<string>) => {
      state.companyCorpName = action.payload;
    },
    setCompanySectorName: (state, action: PayloadAction<string>) => {
      state.companySectorName = action.payload;
    },
    setReportCategoryName: (state, action: PayloadAction<string>) => {
      state.reportCategoryName = action.payload;
    },
    setPostCategoryId: (state, action: PayloadAction<number>) => {
      state.postCategoryId = action.payload;
    },
    setRankCategoryId: (state, action: PayloadAction<number>) => {
      state.rankCategoryId = action.payload;
    },
    setCompanyCorpId: (state, action: PayloadAction<number>) => {
      state.companyCorpId = action.payload;
    },
    setCompanySectorId: (state, action: PayloadAction<number>) => {
      state.companySectorId = action.payload;
    },
    setReportCategoryId: (state, action: PayloadAction<number>) => {
      state.reportCategoryId = action.payload;
    },
  },
});


export const { setPostCategoryName, setRankCategoryName, setCompanyCorpName, setCompanySectorName, setReportCategoryName, setPostCategoryId, setRankCategoryId, setCompanyCorpId, setCompanySectorId, setReportCategoryId } = categorySlice.actions;
export default categorySlice.reducer;
